import {
  Grid,
  FormControl,
  InputLabel,
  ListItemIcon,
  MenuItem,
  Button,
  Paper,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { saveLeaveType, updateLeaveTypeById } from '../../../../Services/MasterdataService';
import {
  SHOW_NOTIFICATION,
  CANCEL_BUTTON_TEXT,
  colorOptionsLeaveType,
} from '../../../../../constants';
import { useDispatch } from 'react-redux';
import { DialogBoxComponent } from '../../../../../components/DialogBox/DialogBoxCard';

const CUSTOM_COLOR_OPTION = '__custom__';
const HEX_COLOR_PATTERN = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

const LeaveTypeForm = (props) => {
  const {
    refresh,
    setRefresh,
    unUsedColor,
    leaveTypesList,
    type,
    data,
    handleFormClose,
    selectedYear,
    setOpenForm,
  } = props;

  const tenantId = process.env.REACT_APP_TENANT_ID;

  const dispatch = useDispatch();

  const [isTextError, setIsTextError] = React.useState(false);
  const [isDaysError, setDaysError] = React.useState(false);
  const [isCarryForwardLeaveError, setIsCarryForwardLeaveError] =
    useState(false);
  const [isEncashmentLeaveError, setIsEncashmentLeaveError] = useState(false);
  const [isCategoryError, setIsCategoryError] = useState(false);
  const [isColorError, setIsColorError] = useState(false);
  const [customColorError, setCustomColorError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [loadingApiCall, setLoadingApiCall] = useState(false);
  const [tempUnusedColor, setTempUnusedColor] = useState([]);
  const [isCustomColor, setIsCustomColor] = useState(false);
  const [customColorInput, setCustomColorInput] = useState('');
  const [temp, setTemp] = React.useState({
    leaveName: '',
    numberOfDays: '',
    leaveCategoryId: '',
    color: '',
    maxCarryForwardLeavesAllowed: '',
    maxEncashmentLeavesAllowed: '',
  });


  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const onAddClick = async () => {
    setOpen(false);
    if (
      temp.leaveName !== '' &&
      temp.numberOfDays !== '' &&
      temp.leaveCategoryId !== '' &&
      temp.color !== '' &&
      temp.maxCarryForwardLeavesAllowed !== '' &&
      temp.maxEncashmentLeavesAllowed !== ''
    ) {
      const leaveType = {
        ...temp,
        tenantId: tenantId,
        year: selectedYear,
      };
      setLoadingApiCall(true);
      console.log(type)
      let response ='';
      if(type==='update'){
        response = await updateLeaveTypeById(leaveType);
      }
      else{
        response = await saveLeaveType(leaveType);
      }
     
      console.log(leaveType)
      setLoadingApiCall(false);
      if (response.isError === false) {
        setRefresh(!refresh);
        setTemp({
          leaveName: '',
          numberOfDays: '',
          color: '',
          leaveCategoryId: '',
          maxCarryForwardLeavesAllowed: '',
          maxEncashmentLeavesAllowed: '',
        });
        setIsCustomColor(false);
        setCustomColorInput('');
        setCustomColorError(false);
      }
      dipatchNotification(response.type, [response.message]);
      setOpen(false);
      handleFormClose();
    }
  };
  const onAdd = async () => {
    if (
      temp.leaveName.trim() === '' ||
      temp.numberOfDays.toString().trim() === '' ||
      temp.leaveCategoryId === '' ||
      temp.color === '' ||
      temp.maxCarryForwardLeavesAllowed.toString().trim() === '' ||
      temp.maxEncashmentLeavesAllowed.toString().trim() === ''
    ) {
      if (temp.leaveName.trim() === '') setIsTextError(true);
      if (temp.numberOfDays.toString().trim() === '') setDaysError(true);
      if (temp.leaveCategoryId === '') setIsCategoryError(true);
      if (temp.color === '') setIsColorError(true);
      if (temp.maxCarryForwardLeavesAllowed.toString().trim() === '')
        setIsCarryForwardLeaveError(true);
      if (temp.maxEncashmentLeavesAllowed.toString().trim() === '')
        setIsEncashmentLeaveError(true);
      return;
    } else {
      setIsTextError(false);
      setDaysError(false);
      setIsCategoryError(false);
      setIsColorError(false);
      setIsCarryForwardLeaveError(false);
      setIsEncashmentLeaveError(false);
    }

    if (isCustomColor) {
      if (!HEX_COLOR_PATTERN.test(temp.color)) {
        setCustomColorError(true);
        return;
      }
      const isColorTaken = (leaveTypesList || []).some(
        (leaveType) =>
          leaveType.color?.toLowerCase() === temp.color.toLowerCase() &&
          leaveType.id !== data?.id,
      );
      if (isColorTaken) {
        setCustomColorError(true);
        dipatchNotification('error', 'This color is already in use by another leave type');
        return;
      }
    }

    if (
      temp.numberOfDays !== '' &&
      (parseInt(temp.numberOfDays) <
        parseInt(temp.maxCarryForwardLeavesAllowed) ||
        parseInt(temp.numberOfDays) < parseInt(temp.maxEncashmentLeavesAllowed))
    ) {
      setDaysError(true);
      return;
    }

    setOpen(true);
    setLoadingApiCall(true);
  };
  const handleClose = () => {
    setOpen(false);
    setLoadingApiCall(false);
  };

  const onCancel = () => {
    setLoadingApiCall(false);
    setTemp({
      leaveName: '',
      numberOfDays: '',
      color: '',
      leaveCategoryId: '',
      maxCarryForwardLeavesAllowed: '',
      maxEncashmentLeavesAllowed: '',
    });
    setIsCustomColor(false);
    setCustomColorInput('');
    setCustomColorError(false);
    setOpen(false);
    handleFormClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'color' && value === CUSTOM_COLOR_OPTION) {
      setIsCustomColor(true);
      setCustomColorError(false);
      setTemp((prevRow) => ({ ...prevRow, color: '' }));
      return;
    }

    if (name === 'numberOfDays' && (isNaN(value) || value < 0 || value > 365)) {
      setDaysError(true);
      return;
    }
    if (
      name === 'maxCarryForwardLeavesAllowed' &&
      (isNaN(value) || parseInt(value) > parseInt(temp.numberOfDays))
    ) {
      setIsCarryForwardLeaveError(true);
      return;
    }

    if (
      name === 'maxEncashmentLeavesAllowed' &&
      (isNaN(value) || parseInt(value) > parseInt(temp.numberOfDays))
    ) {
      setIsEncashmentLeaveError(true);
      return;
    }

    setTemp((prevRow) => {
      return {
        ...prevRow,
        [name]: value,
      };
    });
    if (name === 'leaveName') setIsTextError(false);
    if (name === 'leaveCategoryId') setIsCategoryError(false);
    if (name === 'color') setIsColorError(false);
    if (name === 'numberOfDays') setDaysError(false);
    if (name === 'maxCarryForwardLeavesAllowed')
      setIsCarryForwardLeaveError(false);
    if (name === 'maxEncashmentLeavesAllowed') setIsEncashmentLeaveError(false);
  };

  const getColorLabelFunc = (color) => {
    for (let index = 0; index < colorOptionsLeaveType.length; index++) {
      const element = colorOptionsLeaveType[index];
      if (element.color === color) return element.label;
    }
    return 'Custom';
  };

  const handleCustomColorChange = (event) => {
    const value = event.target.value;
    setCustomColorInput(value);
    setCustomColorError(false);
    setIsColorError(false);
    setTemp((prevRow) => ({ ...prevRow, color: value }));
  };

  useEffect(() => {
    if (type === 'update') {
      setTemp(data);
      const isPresetColor = colorOptionsLeaveType.some(
        (option) => option.color === data.color,
      );
      if (!isPresetColor && data.color) {
        setIsCustomColor(true);
        setCustomColorInput(data.color);
      }
      setTempUnusedColor([
        ...unUsedColor,
        {
          label: getColorLabelFunc(data.color),
          color: data.color,
        },
      ]);
    } else {
      setTempUnusedColor(unUsedColor);
    }
  }, [type, data, unUsedColor]);

  return (
    <>
      <Grid style={{ padding: '20px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              error={isTextError}
              name="leaveName"
              value={temp.leaveName}
              onChange={handleInputChange}
              required
              id="standard-required"
              label="Leave Type"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              error={isDaysError}
              name="numberOfDays"
              value={temp.numberOfDays}
              onChange={handleInputChange}
              required
              id="standard-required"
              label="Number of Days"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ paddingTop: '10px' }}>
          <Grid item xs={12} md={6}>
            <FormControl error={isCategoryError} required fullWidth>
              <InputLabel id="leaveCategory">Leave Category</InputLabel>
              <Select
                labelId="leaveCategory"
                id="leaveCategoryId"
                name="leaveCategoryId"
                value={temp.leaveCategoryId}
                label="Leave Category"
                onChange={handleInputChange}
              >
                <MenuItem value={1}>Manager Approved Leave</MenuItem>
                <MenuItem value={2}>HR Approved Leave</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl error={isColorError} required fullWidth>
              <InputLabel id="leaveColor">Color</InputLabel>
              <Select
                labelId="leaveColor"
                id="leaveColorId"
                name="color"
                value={isCustomColor ? CUSTOM_COLOR_OPTION : temp.color}
                label="Color"
                onChange={handleInputChange}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={(selected) =>
                  selected === CUSTOM_COLOR_OPTION ? (
                    <Paper style={{ display: 'flex', alignItems: 'center' }}>
                      <ListItemIcon>
                        <FiberManualRecordIcon
                          style={{ color: temp.color || '#ccc' }}
                        />
                      </ListItemIcon>
                      Custom
                    </Paper>
                  ) : (
                    <Paper style={{ display: 'flex', alignItems: 'center' }}>
                      <ListItemIcon>
                        <FiberManualRecordIcon style={{ color: selected }} />
                      </ListItemIcon>
                      {getColorLabelFunc(selected)}
                    </Paper>
                  )
                }
              >
                {tempUnusedColor.map((option) => (
                  <MenuItem
                    key={option.color}
                    value={option.color}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <div
                      style={{
                        width: '16px',
                        height: '16px',
                        borderRadius: '50%',
                        backgroundColor: option.color,
                        marginRight: '8px',
                      }}
                    />
                    {option.label}
                  </MenuItem>
                ))}
                <MenuItem
                  value={CUSTOM_COLOR_OPTION}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  Custom color...
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {isCustomColor && (
            <Grid item xs={12} md={6}>
              <TextField
                error={customColorError}
                helperText={
                  customColorError
                    ? 'Enter a valid hex code, e.g. #1A2B3C'
                    : ''
                }
                name="customColor"
                value={customColorInput}
                onChange={handleCustomColorChange}
                required
                fullWidth
                id="custom-color-hex"
                label="Custom Color (hex code)"
                placeholder="#1A2B3C"
                InputProps={{
                  startAdornment: (
                    <div
                      style={{
                        width: '16px',
                        height: '16px',
                        borderRadius: '50%',
                        backgroundColor: HEX_COLOR_PATTERN.test(
                          customColorInput,
                        )
                          ? customColorInput
                          : '#ccc',
                        marginRight: '8px',
                        flexShrink: 0,
                      }}
                    />
                  ),
                }}
              />
            </Grid>
          )}
        </Grid>
        <Grid container spacing={2} style={{ paddingTop: '10px' }}>
          <Grid item xs={12} md={6}>
            <TextField
              error={isCarryForwardLeaveError}
              name="maxCarryForwardLeavesAllowed"
              value={temp.maxCarryForwardLeavesAllowed}
              onChange={handleInputChange}
              required
              id="standard-required"
              label="Maximum Carry Forward Leave Allowed"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              error={isEncashmentLeaveError}
              name="maxEncashmentLeavesAllowed"
              value={temp.maxEncashmentLeavesAllowed}
              onChange={handleInputChange}
              required
              id="standard-required"
              label="Maximum Encashment Leave Allowed"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid
            item
            xs={6}
            md={4}
            style={{
              display: 'flex',
              justifyContent: 'start',
              marginTop: '20px',
            }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                setOpenForm(false);
              }}
            >
              {CANCEL_BUTTON_TEXT}
            </Button>
          </Grid>
          <Grid
            item
            xs={6}
            md={4}
            style={{
              display: 'flex',
              justifyContent: 'end',
              marginTop: '20px',
            }}
          >
            <LoadingButton
              type="submit"
              variant="contained"
              loading={loadingApiCall}
              onClick={() => onAdd()}
            >
              {loadingApiCall
                ? 'loading...'
                : type === 'update'
                  ? 'Update Leave Type'
                  : 'Add Leave Type'}
            </LoadingButton>
          </Grid>
        </Grid>
      </Grid>
      <DialogBoxComponent
        open={open}
        handleClose={handleClose}
        confirmText="Yes"
        cancelText="No"
        content={
          type === 'update'
            ? `Do you want to update the leaveType`
            : `Do you want to add ${temp.leaveName} as a new LeaveType?`
        }
        onConfirm={onAddClick}
        onCancel={onCancel}
      />
    </>
  );
};

export default LeaveTypeForm;
